import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  footerView: { alignSelf: 'stretch', borderBottomLeftRadius: 0, borderBottomRightRadius: 0, marginHorizontal: 0 },
});
export default styles;
